export class StringUtils {
    // Some adapted from EsploroAssetValidations.java
    public static regexDoi = /10\.[^\/]+\/.+/;
    public static regexDoiPartial = /[^\/]+\/.+/;
    public static regexIsbn = /^(\d{9}|\d{12})(x|X|\d)$/;
    public static regexIssn = /^\d{4}-?\d{3}[\d|X|x]$/;
    public static regexPmid = /^\d{1,8}$/;
    public static regexOrcid =
        /^(http(s)?:\/\/(www\.)?orcid.org\/)?\d{4}-\d{4}-\d{4}-\d{3}[\d|X|x]/;

    public static convertStringToHtml(string) {
        return `${string}`;
    }

    public static capitalizeName(string) {
        return string.trim().replace(/\w\S*/g, (txt) => {
            return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
        });
    }

    public static isDoiUrlFormat = (doiUrl: string): boolean =>
        doiUrl?.startsWith('http') &&
        doiUrl?.includes('doi.org') &&
        StringUtils.regexDoi.test(doiUrl);

    public static doiFromUrl = (doiUrl: string) =>
        doiUrl?.match(StringUtils.regexDoi)?.[0];

    public static isDoiFormat = (doi: string): boolean =>
        new RegExp(StringUtils.regexDoi, 'y').test(doi);

    public static isIssnFormat = (s: string): boolean =>
        new RegExp(StringUtils.regexIssn, 'y').test(s);

    public static isPmidFormat = (s: string): boolean =>
        new RegExp(StringUtils.regexPmid, 'y').test(s);

    public static isOrcidFormat = (s: string): boolean =>
        new RegExp(StringUtils.regexOrcid, 'y').test(s);

    public static isNil = (s: any): boolean => s === undefined || s === null;
    public static isNilOrEmpty = (s: string): boolean =>
        StringUtils.isNil(s) || s.trim() === '';
}
